import { useEffect } from 'react'
import { authTokenWatcher } from '../../helpers/authTokenWatcher'
import { handleLogin } from '../../helpers/handleLogin'
import { handleLogout } from '../../helpers/handleLogout'
import { useDispatch } from 'react-redux'
import { remoteLogout, remoteLogin } from '@wellesley/host-remote/api/actions'

export const useAuthTokenWatcher = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    authTokenWatcher.run({
      onLogin: (authToken) => {
        dispatch(remoteLogin())
        handleLogin(authToken)
      },
      onLogout: () => {
        dispatch(remoteLogout())
        handleLogout()
      },
    })
  }, [dispatch])
}
